/**
 * 說明 : 客戶資料與後端API調用的非同步行為
 */
import {createAsyncThunk} from '@reduxjs/toolkit';

import BaseAPI from './BaseAPI';

// 新增客戶資訊
export const addCustomer = createAsyncThunk(
  'customer/addCustomer',
  async ({customer}, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.postWithAuth('/customer', customer, token);
      return data;
    } catch (err) {
      console.error('add customer error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 修改客戶資訊
export const editCustomer = createAsyncThunk(
  'customer/editCustomer',
  async ({customer, isCoordinateOnly}, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      console.log('=== Action 接收到的原始參數 ===', customer);
      // --- 加上這兩行來印出資料 ---
      console.log('=== 準備發送更新請求 ===');
      console.log('Payload 資料內容:', customer);
      console.log('Query 參數 (isCoordinateOnly):', isCoordinateOnly);
      const data = await BaseAPI.putWithAuth('/customer', customer, token, {
        isCoordinateOnly,
      });
      return data;
    } catch (err) {
      console.error('edit department error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 修改客戶狀態
export const editCustomerStatus = createAsyncThunk(
  'customer/editCustomerStatus',
  async ({customerCodes, status}, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.putWithAuth(
        '/customer/status',
        {customerCodes: customerCodes, flgStatus: status},
        token,
      );
      return data;
    } catch (err) {
      console.error('update customer status error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 取得客戶資料
export const fetchCustomer = createAsyncThunk(
  'customer/fetchCustomer',
  async (customerCode, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.getWithAuth(
        `/customer/${customerCode}`,
        null,
        token,
      );
      return data;
    } catch (err) {
      console.error('fetch elevator error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 取得客戶清單列表
export const fetchCustomerList = createAsyncThunk(
  'customer/fetchCustomerList',
  async (
    {customerName, customerCode, contactName},
    {getState, rejectWithValue},
  ) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.getWithAuth(
        '/customer',
        {
          customerName,
          customerCode,
          contactName,
        },
        token,
      );
      return data;
    } catch (err) {
      //   console.error('fetch elevator list error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 取得有效的客戶名稱選單
export const fetchCustomerSelection = createAsyncThunk(
  'customer/fetchCustomerSelection',
  async (
    {isNeededCasesNotAssign = false} = {},
    {getState, rejectWithValue},
  ) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.getWithAuth(
        '/selection/customer',
        {isNeededCasesNotAssign},
        token,
      );
      return data;
    } catch (err) {
      console.error('fetch customer selection error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);
